import { ReactNode, useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { ENV } from 'shared/ENV';

export const PostHogProviderWrapper = ({
  children,
}: {
  children: ReactNode;
}): ReactNode => {
  // This both init's the posthog client and conditionally wraps children in the posthog provider
  if (!ENV.VITE_POSTHOG_ENV || !ENV.VITE_POSTHOG_PUBLIC_KEY) {
    return children;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    posthog.init(ENV.VITE_POSTHOG_PUBLIC_KEY, {
      api_host: 'https://us.i.posthog.com',
      person_profiles: 'identified_only',
      name: import.meta.env.VITE_POSTHOG_ENV,
      capture_pageview: false, // doing this manually: https://posthog.com/tutorials/single-page-app-pageviews
    });
  }, []);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};
